
import React from "react";

export default function Dashboard({ user, onLogout }) {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#f4f6fb",
      fontFamily: "Arial, sans-serif"
    }}>
      <header style={{
        background: "#343a76",
        color: "#fff",
        padding: "20px 35px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <h2>Softvolute ERP</h2>

        <button
          onClick={onLogout}
          style={{
            background: "#fff",
            color: "#343a76",
            border: 0,
            padding: "12px 20px",
            borderRadius: 6,
            cursor: "pointer"
          }}
        >
          Logout
        </button>
      </header>

      <main style={{ padding: 35 }}>
        <h1>Welcome, {user?.name || "Employee"}</h1>
        <p>Softvolute ERP Dashboard</p>
        <p>Role: {user?.role || "employee"}</p>
      </main>
    </div>
  );
}
